module.exports = __webpack_public_path__ + "static/media/objects2_08.39d5ddb4.svg";